import EventHubMixin from '@/mixins/EventHub.js'
import TimeMixin from '@/mixins/Time.js'
import ScrollMixin from '@/mixins/Scroll.js'

import AppIconSound from '@/components/app-icon-sound'
import { TweenLite, Power3 } from 'gsap';

export default
{
    name: 'app-music',

    mixins:
    [
        EventHubMixin,
        TimeMixin,
        ScrollMixin
    ],

    components:
    {
        AppIconSound
    },

    data()
    {
        return {
            playing: false,
            active: true,
            backgroundVisible: false,
            song: 'intro'
        }
    },

    watch:
    {
        $route()
        {
            this.song = 'ambiant'
        },

        song()
        {
            if(this.started)
            {
                this.$audioCurrent = this.song === 'intro' ? this.$audioIntro : this.$audioAmbiant

                TweenLite.to(this.$audioIntro, 5, { ease: Power3.easeOut, volume: 0, onComplete: () =>
                {
                    this.$audioIntro.pause()

                    if(this.shouldPlay && this.playing)
                    {
                        this.$audioAmbiant.currentTime = 0
                        this.$audioAmbiant.volume = 1
                        this.$audioAmbiant.play()
                    }
                } })
            }
        }
    },

    created()
    {
        this.started = false
        this.song = this.$route.meta.name === 'home' ? 'intro' : 'ambiant'
    },

    mounted()
    {
        this.$audioIntro = this.$refs.audioIntro
        this.$audioIntro.volume = this.$root.config.platform.os === 'iOS' ? 1 : 0

        this.$audioAmbiant = this.$refs.audioAmbiant
        this.$audioAmbiant.volume = 0

        this.$audioCurrent = this.song === 'intro' ? this.$audioIntro : this.$audioAmbiant

        this.autoplaySupported = false

        // Wait a moment and considere that autoplay is not working if timeout
        const timeout = window.setTimeout(() =>
        {
            this.$audioCurrent.removeEventListener('play', audioPlayCallback)
            window.clearTimeout(timeout)

            this.start()
        }, 500)

        // Wait for the sound to play and considere autoplay works
        const audioPlayCallback = () =>
        {
            this.autoplaySupported = true

            this.$audioCurrent.removeEventListener('play', audioPlayCallback)
            window.clearTimeout(timeout)

            this.start()
        }

        this.$audioCurrent.addEventListener('play', audioPlayCallback)

        // Try to play
        this.$audioCurrent.play()

        // Listen to event hub
        this.$eventHub.$on('audio.play', this.play)
        this.$eventHub.$on('audio.pause', this.pause)
        this.$eventHub.$on('audio.endPause', this.endPause)
        this.$eventHub.$on('audio.activate', this.activate)
        this.$eventHub.$on('audio.deactivate', this.deactivate)
    },

    methods:
    {
        start()
        {
            this.started = true

            // Test local storage
            const localStorageMusic = window.localStorage.getItem('music', '1')

            // Autoplay supported
            if(this.autoplaySupported)
            {
                if(localStorageMusic && localStorageMusic === '0')
                {
                    this.playing = false
                    this.shouldPlay = false
                }
                else
                {
                    this.playing = true
                    this.shouldPlay = true

                    TweenLite.to(this.$audioCurrent, 0.6, { volume: 1 })
                }
            }

            // Autoplay not supported
            else
            {
                this.playing = false
                this.shouldPlay = false

                // No local storage or local storage say sound can play
                if(!localStorageMusic || localStorageMusic === '1')
                {
                    // Play audio on any click
                    const bodyClickCallback = () =>
                    {
                        document.body.removeEventListener('click', bodyClickCallback)

                        this.playing = true
                        this.shouldPlay = true

                        TweenLite.to(this.$audioCurrent, 0.6, { volume: 1 })

                        this.$audioCurrent.play()
                    }

                    document.body.addEventListener('click', bodyClickCallback)
                }
            }
        },

        onScroll()
        {
            this.backgroundVisible = this.scroll.current > 20
        },

        activate()
        {
            this.active = true
        },

        deactivate()
        {
            this.active = false
        },

        play(userAction = true)
        {
            this.playing = true

            TweenLite.to(this.$audioCurrent, 0.6, { volume: 1 })

            if(this.$root.config.platform.os === 'iOS')
            {
                this.$audioCurrent.play()
            }

            if(userAction)
            {
                this.shouldPlay = true
                window.localStorage.setItem('music', '1')
            }
        },

        pause(userAction = true)
        {
            this.playing = false

            if(this.$root.config.platform.os === 'iOS')
            {
                this.$audioCurrent.pause()
            }

            if(userAction)
            {
                TweenLite.to(this.$audioCurrent, 0.6, { volume: 0 })

                this.shouldPlay = false
                window.localStorage.setItem('music', '0')
            }
            else
            {
                TweenLite.to(this.$audioCurrent, 2, { volume: 0 })
            }
        },

        endPause()
        {
            if(this.shouldPlay)
            {
                if(this.$root.config.platform.os === 'iOS')
                {
                    this.$audioCurrent.play()
                }

                TweenLite.to(this.$audioCurrent, 0.6, { volume: 1 })

                this.playing = true
                window.localStorage.setItem('music', '1')
            }
        },

        onClick()
        {
            // If not iOS, try to play
            if(this.$root.config.platform.os !== 'iOS')
            {
                this.$audioCurrent.play()
            }

            if(this.playing)
            {
                this.pause(true)
            }
            else
            {
                this.play(true)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-music/script.js